import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import ApiGo from '../../../actions/ApiGo'
import WIFIIcon from '../Device/icon/WIFI_Icon'
import { ScanningAnimation } from './Internet_settings'
import { useDispatch } from 'react-redux'
import { ADD_RESPONSE } from '../../../stores/reducer_add'
import comm_imgs from '../../../comm_imgs'

// const WIFI_Authentic = ["WPA-Personal", "WPA-EAP", "Open System"]
const WIFI_Authentic = ["WPA-Personal", "Open System"]
const EAP_type=["PEAP", "TLS", "TTLS"]
// const Personal_type=["WPA", "WPA2","WEP (ASCII)", "WEP (HEX)"]
const Key_Managment_type = ["psk", "eap", "802.1x"]
// const WIFI_options=["MWG", "MWG_5G"]

const RowBarInternet =(props)=>{
    const [open_setting, setOpen_setting] = useState(false);
    function toggle_open_setting() {
        setOpen_setting(!open_setting)
    }
    return(
        <div className="wid-100 row_hover hig-7 btm_line_light margb-xxxs mx-2 fx-d-r fx-cfs bar_row padl-m cursor-pointer" onClick={toggle_open_setting}>
            <div className="pos-a trans_y10">
                <WIFIIcon rssi={props.signal_level} size={'s'}/>
                {props.encryption==="on"?<img className="wid-admin-1vw pos-a trans_x5 trans_y5" src={comm_imgs.WIFI_LOCK} />:null}
            </div>
            <div className="wid-admin-l margl-m fx-cc">{(props.wifi===""?"未命名網路":props.wifi)}</div>
            {open_setting?
                props.encryption==="on"?
                    <WIFISETTINGS
                        open_setting={open_setting}
                        hide={toggle_open_setting}
                        wifi={props}
                        setRefresh_current_wifi_after_change = {props.setRefresh_current_wifi_after_change}
                        />
                    :<WIFISETTINGS_UNENCRYPTION
                        open_setting={open_setting}
                        hide={toggle_open_setting}
                        wifi={props}
                        setRefresh_current_wifi_after_change = {props.setRefresh_current_wifi_after_change}/>
            :null}
        </div>
    );

}
export default RowBarInternet;

const WIFISETTINGS = (props)=>{
    const dispatch = useDispatch()
    const {t} = useTranslation()
    const [selected_WPA, setSelected_WPA] = useState("WPA-Personal");
    const [keyManagement, setKeyManagement] = useState("");
    // const [seleted_encrpt_type, setSeleted_encrpt_type] = useState("");
    const [pwd, setPwd] = useState("");
    const [show_animation, setShow_animation] = useState(false);
    const [wrong_type, setWrong_type] = useState('nothing_happend');
    let wifi = props.wifi


    function post_wifi_connect() {
        setShow_animation(true)
        let data = {
            "connection_method": "wifi_setting",
            "essid": wifi.wifi,
            "pwd": pwd
        }
        ApiGo.postWifi_connect(data)
        .then(res=>{
            if(res==="connected"){
                setWrong_type("success")
                setTimeout(()=>{
                    props.hide()
                }, 1000)
                dispatch(ADD_RESPONSE({status:200, statusText:"success", type:"wifi_setting"}))
                props.setRefresh_current_wifi_after_change(true)
                setShow_animation(false)
            }
        })
        .catch(err=>{
            if(err==="wifi密碼錯誤，已還原初始設定!"){
                setWrong_type("wrong_pwd")
            }else{
                setWrong_type("wrong_input_type")
            }
        })
    }
    return (
        <div className="wid-admin-full hig-full pos-f t-0 r-0 fx-cc cursor_style default" onClick={props.hide}>
            {(show_animation)?<ScanningAnimation scan_style={"connecting"} wrong_type={wrong_type} hide={props.hide}/>:null}
            <div className={`${(selected_WPA==="WPA-EAP")?"wid-admin-70":"wid-admin-side"} hig-60 fx-d-c bgC-white border shadow-s-noHover br-20 cursor_style default`} onClick={e=>e.stopPropagation()}>
                <div className="fx-d-r margt-5-vh hig-l fx-cspar">
                    <div className="fx-d-c hig-l">
                        <div className="font-l">{t("ADMIN.WIFI_CONNECTION")}</div>
                        <div className="fx-d-r margt-m">
                            <div className="wid-admin-s"> AP ：</div>
                            <div>{wifi.wifi}</div>
                        </div>
                        <div className="fx-d-r margt-s"><div className="wid-admin-s">{t("ADMIN.NETWORK_SETTING.Authentication")}：</div>
                            <div>WPA</div>
                        </div>
                        {(selected_WPA==="WPA-EAP")?
                            <div className="fx-d-r margt-xs"><div className="wid-admin-s">{t("ADMIN.NETWORK_SETTING.KEY_MANAGE")}：</div><select className="wid-admin-15"
                                    onChange={e=>{setKeyManagement(e.target.value)}}
                                    value={keyManagement}>
                                {Key_Managment_type.map((WPA, index)=>{return <option key={WPA+index}>{WPA}</option>})}
                            </select></div>:null}
                        {(selected_WPA==="WPA-Personal")?<WPAPersonal setPwd={setPwd} pwd={pwd} />:
                            (selected_WPA==="WPA-Personal")?
                                <select className="wid-admin-15"
                                    onChange={e=>{setSelected_WPA(e.target.value)}}
                                    value={selected_WPA}>
                                    {EAP_type.map((WPA, index)=>{
                                        return <option key={WPA+index}>{WPA}</option>
                                    })}
                                </select>:null}
                    </div>
                </div>
                <div className={`fx-d-r fx-cspar ${(selected_WPA==="WPA-EAP")?"wid-admin-70":"wid-admin-side"} margt-s`}>
                    <div className="wid-admin-xs hig-xs bgC-alert-E br-10 shadow-xs fx-cc" onClick={post_wifi_connect}>{t("ADMIN.NETWORK_SETTING.CONNECTION")}</div>
                    <div className="wid-admin-xs hig-xs bgC-alert-EE br-10 shadow-xs fx-cc" onClick={props.hide}>{t("GLOBAL.CANCEL")}</div>
                </div>
            </div>
        </div>
    )
}


const WIFISETTINGS_UNENCRYPTION = (props)=>{
    const dispatch = useDispatch()
    const {t} = useTranslation()
    const [show_animation, setShow_animation] = useState(false);
    const [wrong_type, setWrong_type] = useState('nothing_happend');
    let wifi = props.wifi
    function post_wifi_connect() {
        setShow_animation(true)
        let data = {
            "connection_method": "wifi_setting",
            "essid": wifi.wifi,
            "pwd": ""
        }
        ApiGo.postWifi_connect(data)
        .then(res=>{
            if(res==="connected"){
                setWrong_type("success")
                setTimeout(()=>{
                    props.hide()
                }, 1000)
                dispatch(ADD_RESPONSE({status:200, statusText:"success", type:"wifi_setting"}))
                props.setRefresh_current_wifi_after_change(true)
                setShow_animation(false)
            }
        })
        .catch(err=>{})
    }
    return (
        <div className="wid-admin-full hig-full pos-f t-0 r-0 fx-cc cursor_style default" onClick={props.hide}>
            {(show_animation)?<ScanningAnimation scan_style={"connecting"} wrong_type={wrong_type} hide={props.hide}/>:null}
            <div className={`wid-admin-side hig-60 fx-d-c bgC-white border shadow-s-noHover br-20 cursor_style default`} onClick={e=>e.stopPropagation()}>
                <div className="fx-d-r margt-5-vh hig-l fx-cspar">
                    <div className="fx-d-c hig-l">
                        <div className="font-l">{t("ADMIN.WIFI_CONNECTION")}</div>
                        <div className="fx-d-r margt-m">
                            <div className="wid-admin-s"> AP ：</div>
                            <div>{wifi.wifi}</div>
                        </div>
                    </div>
                </div>
                <div className={`fx-d-r fx-cspar wid-admin-side margt-s`}>
                    <div className="wid-admin-xs hig-xs bgC-alert-E br-10 shadow-xs fx-cc" onClick={post_wifi_connect}>{t("ADMIN.NETWORK_SETTING.CONNECTION")}</div>
                    <div className="wid-admin-xs hig-xs bgC-alert-EE br-10 shadow-xs fx-cc" onClick={props.hide}>{t("GLOBAL.CANCEL")}</div>
                </div>
            </div>
        </div>
    )
}

// for WPA, WEP
const WPAPersonal = (props)=>{
    const {t} = useTranslation()
    return(
        <div className="margt-s">
            <div className="fx-d-r">
                <div className='wid-admin-s margr-xs'>{t("GLOBAL.PASSWORD")}：</div>
                <input type="text" className='btm_line margl-xs' onChange={e=>{props.setPwd(e.target.value)}} value={props.pwd} />
            </div>
        </div>
    )
}

// for WPA, WEP
const WPAEAP = (props)=>{
    const {t} = useTranslation()
    return(
        <div className="fx-d-c hig-l fx-cspar br-10 bgC-grey pad-20px">
            <div className="fx-d-r">
                <div className="wid-admin-15">anonymous-id：</div>
                <input type="text" />
            </div>
            <div className="fx-d-r">
                <div className="wid-admin-15">id：</div>
                <input type="text" />
            </div>
            <div className="fx-d-r">
                <div className="wid-admin-15">wifi {t("GLOBAL.PASSWORD")}</div>
                <input type="text" className='btm_line' />
            </div>
            <div className="fx-d-r">
                <div className="wid-admin-15"> CA {t("ADMIN.NETWORK_SETTING.Authentication")}({t("ADMIN.NETWORK_SETTING.ACCESS_ROUTE")})：</div>
                <input type="text" />
            </div>
            <div className="fx-d-r">
                <div className="wid-admin-15">client CA({t("ADMIN.NETWORK_SETTING.ACCESS_ROUTE")})：</div>
                <input type="text" />
            </div>
            <div className="fx-d-r">
                <div className="wid-admin-15">client key：</div>
                <input type="text"
                        value="(存取路徑)"
                        className="font-gray"/>
            </div>
            <div className="fx-d-r">
                <div className="wid-admin-15">client key password:</div>
                <input type="text" />
            </div>
        </div>
    )
}